import { render } from "./LoadingPlaceholder.vue?vue&type=template&id=20b3b52e"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"

import "./LoadingPlaceholder.vue?vue&type=style&index=0&id=20b3b52e&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__